import { ActionReducer, ActionReducerMap, createSelector, MetaReducer } from "@ngrx/store";
import { authReducer, AuthState } from "app/modules/auth/_state/auth.reducers";
import { DashboardReducer, DashboardState } from "app/modules/dashboard/_state/dashboard.reducers";
import { environment } from "environments/environment";
import { logout } from '../modules/auth/_state/auth.actions';


export interface AppState {
    auth: AuthState
    dashboard: DashboardState
}

export const reducers: ActionReducerMap<AppState> = {
    auth: authReducer,
    dashboard: DashboardReducer,
}

export function flush(reducer: ActionReducer<any>): ActionReducer<any> {
    return function(state, action) {
        if (action.type === logout.type) {
            return reducer(undefined, action);
        }
        return reducer(state, action);
    };
}

//Dashboard
export const selectDashboardState = (state: AppState) => state.dashboard
export const selectOutstandingBalance = createSelector(selectDashboardState, (state: DashboardState) => state.outstandingBalance)
export const selectOutstandingBalanceLoading = createSelector(selectDashboardState, (state: DashboardState) => state.loadingOutstandingBalance)
export const selectOutstandingBalanceError = createSelector(selectDashboardState, (state: DashboardState) => state.outstandingBalanceError)

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [flush] : [flush];